import { featuredProducts } from '@/mocks/categories';

export default function ProductShowcase() {
  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight">
            Popular Spreadsheets
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg">
            Our most downloaded and community-approved CSSBuy shopping lists
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredProducts.map((product, idx) => (
            <article key={product.name} className="group rounded-2xl bg-background-100 overflow-hidden border border-background-200/60">
              <div className="relative w-full h-[320px] md:h-[360px] overflow-hidden">
                <img
                  src={product.imageUrl}
                  alt={product.name}
                  title={`${product.name} - CSSBuy Spreadsheet Collection`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6 text-center">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1">{product.name}</h3>
                <p className="text-xs text-foreground-400 mb-4">{product.price}</p>
                <button
                  onClick={() => handleClick(product.url)}
                  className={`inline-flex items-center px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    idx === 0
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'bg-transparent text-foreground-700 border border-foreground-300 hover:bg-foreground-100'
                  }`}
                >
                  View Spreadsheet
                </button>
                <p className="mt-3 text-xs text-foreground-400">{product.count}+ items curated</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}